import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  // Para garantir que o layout seja responsivo
  @media (max-width: 768px) {
    flex-direction: column; /* Empilhamento vertical em telas menores */
  }

  & > :first-child {
    flex: 0 0 10%; /* 10% para o topo */
  }

  & > :last-child {
    flex: 1; /* 90% para o conteúdo restante */
  }
`;

export const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column-start: 2;
  grid-row-start: 1;
`;
export const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContainerLista = styled.section`
  width: 100%;

  min-width: 20rem;
  overflow: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column; /* empilha os itens em coluna */
  justify-content: flex-start;
  align-items: center; /* centraliza horizontalmente */

  @media (max-width: 799px) {
    padding: 0.5rem;
    min-width: 100%;
  }

  @media (max-width: 399px) {
    padding: 0.25rem;
    min-width: 100%;
  }
`;

export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

export const ContainerItems = styled.div`
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: linear-gradient(135deg, #f9f9f9, #ffffff);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
`;
export const Items = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  strong {
    font-weight: bold;
    color: #555;
  }
`;
export const Icon = styled.span`
  font-size: 16px;
  color: #666;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

export const StyledButton = styled.button`
  margin-bottom: 10px;
  width: 100%;
`;
